<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-ticket mr-2" />Detail Invoice</h5>
            <hr />
            <b-row>
                <b-col md="6">
                    No. Invoice <strong>{{ data.no_faktur }}</strong><br />
                    No. Ref <strong>{{ data.no_ref }}</strong><br />
                    Divisi: <strong>{{ data.division }}</strong><br />
                    Invoice untuk <strong>{{ data.customer_name }}</strong><br />
                    Invoice dari <strong>{{ data.warehouse }} - {{ data.office }}</strong><br />
                    Status Invoice: <strong>{{ data.status == 2 ? "Ongoing" : data.status == 3 ? "Lunas" : "Error" }}</strong><br />
                    Ditransaksikan oleh <strong>{{ data.confirmed_by }}</strong> pada {{ $helper.parseDate(data.confirmed_at) }}, {{ $helper.parseHourMinute(data.confirmed_at) }}<br />
                    Tanggal Penjualan: <strong>{{ $helper.parseDate(data.sold_at) }}</strong><br />
                    Catatan Invoice: {{ data.note || "-" }}
                </b-col>
                <b-col md="6" class="text-right">
                    <b-button variant="dark" @click="confirmReprintInvoice">
                        <i class="fa fa-print mr-2" />Cetak Invoice
                    </b-button>
                    <div class="mt-2">
                        <b-button variant="primary" @click="showPayments">
                            <i class="fa fa-dollar mr-2" />Lihat Pembayaran
                        </b-button><br>
                        <b-button v-if="data.status == 2" variant="primary" class="mt-3" @click="promptEditInvoice">
                            <i class="fa fa-pencil mr-2" />Ubah Detail Invoice
                        </b-button>
                    </div>
                </b-col>
            </b-row>
            <hr />
            <div class="brand-card-body" style="padding: 0">
                <div>
                    <div class="text-value">{{ data.total_item }} ({{ data.total_return }})</div>
                    <div class="text-uppercase text-muted small">Total Item (Total Retur)</div>
                </div>
                <div>
                    <div class="text-value">Rp. {{ $helper.formatThousand(data.subtotal) }}</div>
                    <div class="text-uppercase text-muted small">Subtotal</div>
                </div>
                <div>
                    <div class="text-value">Rp. {{ $helper.formatThousand(data.total) }}</div>
                    <div class="text-uppercase text-muted small">Total</div>
                    <div class="text text-muted small">DISKON : <strong>{{ data.discount }}%</strong> & <strong>Rp. {{$helper.formatThousand(data.discount_value)}}</strong></div>
                </div>
                <div>
                    <div class="text-value">Rp. {{ $helper.formatThousand(data.outstanding) }}</div>
                    <div class="text-uppercase text-muted small">Sisa Pembayaran</div>
                </div>
            </div>
            <hr />
            <b-row class="mt-3">
                <b-col md="4">
                    <b-form-group label="Pencarian No. Faktur / IMEI SN" description="Ketik RETUR untuk melihat barang retur">
                        <b-form-input v-model="filterInput" maxlength="50" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :items="data.items"
                :fields="fields"
                :filter="filterInput"
                :filter-included-fields="['no_faktur_pgi', 'imei_sn', 'is_returned']"
                responsive
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty>
                    Invoice kosong.
                </template>
                <template v-slot:cell(selection)="row">
                    <div v-if="row.item.is_returned == null && row.item.return_requested == false">
                        <b-button :variant="row.item.selectedForReturn ? 'primary' : 'dark'" size="sm" @click="processReturn(row.item)">
                            <i :class="row.item.selectedForReturn ? 'fa fa-check' : 'fa fa-minus'" />
                        </b-button>
                    </div>
                </template>
                <template v-slot:cell(barang)="row">
                    {{ row.item.type }} <span v-if="row.item.year != null">({{ row.item.year }})</span>
                    <div class="small text-muted">
                        {{ row.item.kind }} - {{ row.item.brand }}<br />
                        Ctt: {{ row.item.note || "-" }}
                    </div>
                </template>
                <template v-slot:cell(noFakturImei)="row">
                    {{ row.item.no_faktur_pgi }}
                    <div class="small text-muted">
                        {{ row.item.imei_sn }}<br />
                        Grade <strong>{{ row.item.grade }} - {{ row.item.spec }} - {{ row.item.is_batangan ? 'BATANG' : 'LENGKAP' }}</strong><br />
                        Kloter {{ $helper.parseDate(row.item.created) }}
                    </div>
                </template>
                <template v-slot:cell(price)="row">
                    Rp. {{ $helper.formatThousand(row.item.base_price) }}
                    <div class="small text-muted">
                        Adj. Rp. {{ $helper.formatThousand(row.item.adjustment) }}<br />
                        Diskon Rp. {{ $helper.formatThousand(row.item.discount) }}
                    </div>
                </template>
                <template v-slot:cell(subtotal)="row">
                    Rp. {{ $helper.formatThousand(row.item.total) }}<br />
                    <b-badge v-if="row.item.is_returned == 'RETUR'" variant="warning">RETUR</b-badge>
                    <b-badge v-else-if="row.item.return_requested == true" variant="warning">RETUR REQUESTED</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="dark" v-b-tooltip.hover.top title="Adjustment" @click="showAdjustments(row.item)">
                        <i class="fa fa-fw fa-list" />
                    </b-button>
                    <b-button v-if="row.item.is_returned == 'RETUR'" size="sm" class="ml-2" variant="warning" v-b-tooltip.hover.top title="Data Retur" @click="showReturDetail(row.item)">
                        <i class="fa fa-fw fa-info" />
                    </b-button>
                </template>
            </b-table>
            <div class="mt-4 text-right">
                <b-button variant="danger" @click="confirmReturnItems">
                    Retur Barang Terpilih
                </b-button>
            </div>
        </b-card>
        <b-modal id="m-adjustment" title="Daftar Adjustment" centered hide-footer>
            Adjustment:
            <ul v-if="activeItem.adjustments.length > 0">
                <li v-for="(item, index) in activeItem.adjustments" v-bind:key="index">
                    {{ item.name }}: Rp. {{ $helper.formatThousand(item.adjustment) }}
                </li>
            </ul>
            <ul v-else>
                <li>Barang ini tidak memiliki adjustment</li>
            </ul>
        </b-modal>
        <b-modal id="m-retur-input" title="Input Retur Barang" centered hide-footer no-close-on-backdrop no-close-on-esc>
            Melakukan retur barang untuk {{ activeItem.type }} (NF {{ activeItem.no_faktur_pgi }})<br />
            <b-form-group class="mt-3" label="Alasan Retur">
                <b-input v-model="input.reason" maxlength="150" />
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="addToReturn">
                    {{ isSubmitting ? "Memproses..." : "Tambahkan ke Retur" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-retur" title="Retur Barang" centered hide-footer no-close-on-backdrop no-close-on-esc>
            Melakukan retur barang untuk:<br />
            <ul>
                <li v-for="item in itemsToReturn" v-bind:key="item.id">
                    NF <b>{{ item.noFaktur }}</b> ({{ item.type }})<br />
                    Ket: {{ item.returnNote }}
                </li>
            </ul>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execReturn">
                    {{ isSubmitting ? "Memproses..." : "Retur Barang" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-retur-detail" title="Detail Retur" centered hide-footer>
            Retur dilakukan oleh <strong>{{ activeItem.returned_data.by }}</strong> pada {{ $helper.parseDate(activeItem.returned_data.at) }}, {{ $helper.parseHourMinute(activeItem.returned_data.at) }}
            <div class="mt-4">
                <strong>Alasan Retur</strong><br />
                {{ activeItem.returned_data.reason }}
            </div>
        </b-modal>
        <b-modal id="m-retur-success" title="Retur Barang Berhasil" centered hide-footer no-close-on-backdrop no-close-on-esc hide-header-close>
            Retur berhasil disimpan, dengan perincian pembayaran sebagai berikut:
            <ul class="mt-2">
                <li v-for="item in returResult.invoices" v-bind:key="item.no_faktur">
                    {{ item.no_faktur }} - <strong>Rp. {{ $helper.formatThousand(item.amount) }} <span v-if="item.is_settled == true">[LUNAS]</span></strong>
                </li>
                <li v-if="returResult.debt != 0">
                    Sebagai hutang ke customer / deposit - <strong>Rp. {{ $helper.formatThousand(returResult.debt) }}</strong>
                </li>
            </ul>
            <div class="mt-4">
                Tekan bagian "Sinar Mutiara Cell" untuk mencetak faktur retur.
                <iframe :src="$BASE_PRINT_FILE_PATH + getReturnInvoiceLink()" height="300px" width="100%" />
            </div>
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="returnInvoiceSizeCooldown" @click="toggleReturnInvoiceSize">
                            Print {{ returnInvoiceSize == 'A5' ? 'A4' : 'A5' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="$bvModal.hide('m-retur-success')">
                            OK
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-modal id="m-retur-request-success" title="Request Retur Barang Berhasil" centered hide-footer no-close-on-backdrop no-close-on-esc hide-header-close>
            Request untuk retur berhasil disimpan, silahkan hubungi admin untuk proses approval.
            <div class="mt-4 text-right">
                <b-button variant="primary" @click="$bvModal.hide('m-retur-request-success')">
                    OK
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-payments" title="Pembayaran Invoice" size="lg" no-close-on-backdrop no-close-on-esc hide-footer>
            <ModalInvoicePayments :invoiceId="$route.params.id" />
        </b-modal>
        <b-modal id="m-reprint-invoice" title="Cetak Ulang Invoice" centered hide-footer>
            Tekan bagian "Sinar Mutiara Cell" untuk mencetak.
            <iframe :src="getInvoiceLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="invoiceSizeCooldown" @click="toggleInvoiceSize">
                            Print {{ invoiceSize == 'A5' ? 'A4' : 'A5' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="$bvModal.hide('m-reprint-invoice')">
                            OK
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-modal id="m-pin" :title="pinTitle" centered hide-footer>
            <b-form-group label="Masukan PIN">
                <b-input type="password" v-model="pin" maxlength="10" @keydown.enter="checkPIN()" autofocus />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="checkPIN()">
                    Otorisasi
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-edit" title="Ubah Invoice" centered hide-footer>
            <b-form-group label="No. Ref Invoice" description="Maks. 20 karakter.">
                <b-input v-model="edit.noRef" maxlength="20" />
            </b-form-group>
            <b-form-group label="Catatan Invoice">
                <b-input v-model="edit.note" maxlength="200" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting || (edit.noRef == null && edit.note == null)" @click="confirmEditInvoice">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ModalInvoicePayments from './ModalInvoicePayments.vue'

export default {
    components: {
        ModalInvoicePayments
    },
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            isFetching: false,

            filterInput: "",
            returResult: {},
            pin: "",
            pinTitle: "",
            afterPin: "",

            input: {
                reason: "",
                warehouse: null
            },

            data: {
                items: []
            },

            fields: [
                { key: "barang", label: "Barang", sortable: true },
                { key: "noFakturImei", label: "No. Faktur & IMEI / SN", sortable: true },
                { key: "price", label: "Harga, Diskon, Adj", sortable: true },
                { key: "subtotal", label: "Subtotal", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            activeItem: {
                adjustments: [],
                returned_data: {}
            },

            itemsToReturn: [],

            optWarehouse: [],

            canReturn: false,

            edit: {
                noRef: "",
                note: ""
            },

            sortBy: null,
            sortDesc: false,

            invoiceSize: 'A5',
            invoiceSizeCooldown: false,

            returnInvoiceSize: 'A5',
            returnInvoiceSizeCooldown: false

        }
    },

    watch: {

        "finalize.dp": function(newVal) {

            let cleaned = String(newVal).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.$nextTick(() => this.finalize.dp = res)

        }

    },

    methods: {

        init() {

            this.initStatus = 0

            let getData = this.getItems()

            let getWarehouses = this.$axios.get("master/warehouse/selection").then(res => {
                this.optWarehouse = res.data.data
            })

            Promise.all([getData, getWarehouses]).then(() => {
                this.initStatus = 1
            })
            .catch(error => this.initStatus = -1)

        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getItems() {
            let param = ""
            if(!this.$helper.isBlank(this.sortBy)) {
                param += "?sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }
            return this.$axios.get("invoice/detail/" + this.$route.params.id + param).then(res => {

                let data = res.data.data

                // Cek apabila invoice ini masih boleh melakukan retur
                this.fields.unshift({ key: "selection", label: "Retur?" })
                data.items.forEach(it => {
                    it.selectedForReturn = false
                    it.returnNote = ""
                })

                this.canReturn = data.can_return
                // if(data.can_return == true) {



                // }

                this.data = data

            })
            .catch(error => this.$helper.parseError(this, error))
        },

        getInvoiceLink() {
            if(this.invoiceSize == 'A5'){
                return `${this.$BASE_PRINT_FILE_PATH}/umgtinvce/${this.$route.params.id}-${this.data.timestamp}-${this.data.timestamp2}`
            }
            else{
                return `${this.$BASE_PRINT_FILE_PATH}/umgtinva4/${this.$route.params.id}-${this.data.timestamp}-${this.data.timestamp2}`
            }
        },

        toggleInvoiceSize() {
            this.invoiceSizeCooldown = true
            if(this.invoiceSize == 'A5') this.invoiceSize = 'A4'
            else this.invoiceSize = 'A5'
            setTimeout(function(){
                this.invoiceSizeCooldown = false
            }.bind(this),2000);
        },

        getReturnInvoiceLink() {
            if(this.returnInvoiceSize == 'A5'){
                return this.returResult.link
            }
            else{
                return this.returResult.linka4
            }
        },

        toggleReturnInvoiceSize() {
            this.returnInvoiceSizeCooldown = true
            if(this.returnInvoiceSize == 'A5') this.returnInvoiceSize = 'A4'
            else this.returnInvoiceSize = 'A5'
            setTimeout(function(){
                this.returnInvoiceSizeCooldown = false
            }.bind(this),2000);
        },

        showAdjustments(item) {

            this.activeItem = item
            this.$bvModal.show("m-adjustment")

        },

        showRetur(item) {
            this.activeItem = item
            this.$bvModal.show("m-retur")
        },

        showReturDetail(item) {
            this.activeItem = item
            this.$bvModal.show("m-retur-detail")
        },

        showPayments() {
            this.$bvModal.show("m-payments")
        },

        processReturn(item) {

            this.activeItem = item
            if(this.activeItem.selectedForReturn) {
                let isConfirmed = confirm("Hapus barang ini dari daftar barang yang akan diretur?")
                if(!isConfirmed) return

                item.selectedForReturn = false
                item.returnNote = ""
            }
            else {
                this.$bvModal.show("m-retur-input")
            }

        },

        addToReturn() {

            if(this.$helper.isBlank(this.input.reason)) {
                return this.$helper.toastError(this, "Mohon mengisi keterangan!")
            }

            this.activeItem.selectedForReturn = true
            this.activeItem.returnNote = this.input.reason
            this.input.reason = ""
            this.$bvModal.hide("m-retur-input")

        },

        confirmReturnItems() {

            this.itemsToReturn = []
            this.data.items.forEach(it => {
                if(it.selectedForReturn) {
                    this.itemsToReturn.push({
                        id: it.id,
                        noFaktur: it.no_faktur_pgi,
                        type: it.type,
                        returnNote: it.returnNote
                    })
                }
            })

            if(this.itemsToReturn.length == 0) return this.$helper.toastError(this, "Mohon memilih minimal 1 barang untuk diretur!")
            this.$bvModal.show("m-retur")

        },

        execReturn() {

            let isConfirmed = confirm("Lakukan retur untuk barang-barang ini?")
            if(!isConfirmed) return

            this.isSubmitting = true

            let invoiceDetails = []
            this.itemsToReturn.forEach(it => {
                invoiceDetails.push({
                    id: it.id,
                    reason: it.returnNote
                })
            })

            let payload = {
                invoice_id: this.$route.params.id,
                invoiceDetails: invoiceDetails
            }

            this.$axios.post("invoice/return-items", payload).then(res => {

                this.returResult = res.data.data
                if(this.returResult.status == "RETUR"){
                    this.$bvModal.show("m-retur-success")
                }else{
                    this.$bvModal.show("m-retur-request-success")
                }

                this.$bvModal.hide("m-retur")
                this.input.reason = ""
                this.init()

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        confirmReprintInvoice() {

            this.afterPin = "reprint-invoice"
            this.pinTitle = "Cetak Ulang Invoice"
            this.$bvModal.show("m-pin")

        },

        promptEditInvoice() {

            this.$bvModal.show("m-edit")

        },

        confirmEditInvoice() {

            this.afterPin = "edit-invoice"
            this.pinTitle = "Perubahan Invoice"
            this.$bvModal.show("m-pin")

        },

        execEditInvoice() {

            this.isSubmitting = true
            let payload = {
                id: this.$route.params.id,
                noRef: this.edit.noRef,
                note: this.edit.note
            }

            this.$axios.post("invoice/update-invoice-final", payload).then(res => {
                this.$helper.toastSuccess(this, "Detail Invoice berhasil diubah!")
                this.init()
                this.$bvModal.hide("m-edit")
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        checkPIN() {

            if(this.pin == "") return this.$helper.toastError(this, "PIN kosong!")

            let payload = {
                pin: this.pin
            }

            this.isSubmitting = true
            this.$axios.post("invoice/check-pin", payload).then(_ => {
                this.pin = ""
                this.$bvModal.hide("m-pin")
                switch(this.afterPin){
                    case 'reprint-invoice':
                        this.$bvModal.show("m-reprint-invoice")
                        break
                    case 'edit-invoice':
                        this.execEditInvoice()
                        break
                }
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        }

    },
    created() {
        this.init()
    }
}
</script>

<style>

</style>
